import { numberRequired, numberOptional, boolean, enumRequired, labeled } from '../../util/joi';
import { schema as ownershipSchema } from './Ownership.schema';
import { schema as addressSchema } from '../address/Address.schema';

import { propertyTypes } from '../global/PropertyType.enum';
import { vehicleTypes } from '../global/VehicleType.enum';
import { zoningOptions } from '../global/ZoningOption.enum';
import { ownershipTypes } from '../global/OwnershipType.enum';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      value: numberOptional(Joi, 0).label(labeled(label, 'Value'))
    })
    .when('.assetType.id', {
      is: 'investment_property_address',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(
          labeled(label, 'Investment Property Asset - Value')
        ),
        ownership: ownershipSchema(Joi, labeled(label, 'Investment Property Asset -')),
        zoning: Joi.any().when('$isAssetFinance', {
          is: true,
          then: Joi.any(),
          otherwise: enumRequired(
            Joi,
            zoningOptions,
            labeled(label, 'Investment Property Asset - Zoning')
          )
        }),
        propertyType: Joi.any().when('$isAssetFinance', {
          is: true,
          then: Joi.any(),
          otherwise: enumRequired(
            Joi,
            propertyTypes,
            labeled(label, 'Investment Property Asset - Property type')
          )
        }),
        address: addressSchema(Joi, labeled(label, 'Investment Property Asset -'))
      })
    })
    .when('.assetType.id', {
      is: 'owner_occupier_property_address',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(
          labeled(label, 'Owner Occupied Property Asset - Value')
        ),
        ownership: ownershipSchema(Joi, labeled(label, 'Owner Occupied Property Asset -')),
        zoning: Joi.any().when('$isAssetFinance', {
          is: true,
          then: Joi.any(),
          otherwise: enumRequired(
            Joi,
            zoningOptions,
            labeled(label, 'Owner Occupied Property Asset - Zoning')
          )
        }),
        propertyType: Joi.any().when('$isAssetFinance', {
          is: true,
          then: Joi.any(),
          otherwise: enumRequired(
            Joi,
            propertyTypes,
            labeled(label, 'Owner Occupied Property Asset - Property type')
          )
        }),
        address: addressSchema(Joi, labeled(label, 'Owner Occupied Property Asset -'))
      })
    })
    .when('.assetType.id', {
      is: 'vehicle_make_and_model',
      then: Joi.object({
        vehicleType: enumRequired(Joi, vehicleTypes, labeled(label, 'Vehicle - Vehicle Type')),
        value: numberRequired(Joi, 1).label(labeled(label, 'Vehicle - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Vehicle -'))
      })
    })
    .when('.assetType.id', {
      is: 'bank_accounts',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(labeled(label, 'Bank accounts - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Bank accounts -'))
      })
    })
    .when('.assetType.id', {
      is: 'home_contents',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(labeled(label, 'Home contents - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Home contents -'))
      })
    })
    .when('.assetType.id', {
      is: 'kiwisaver',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(labeled(label, 'Kiwisaver - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Kiwisaver -'))
      })
    })
    .when('.assetType.id', {
      is: 'superfund_institution',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(labeled(label, 'Superfund institution - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Superfund institution -'))
      })
    })
    .when('.assetType.id', {
      is: 'shares',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(labeled(label, 'Shares - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Shares -'))
      })
    })
    .when('.assetType.id', {
      is: 'other',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(labeled(label, 'Other - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Other -'))
      })
    })
    .when('.assetType.id', {
      is: 'balance_sheet',
      then: Joi.object({
        value: numberRequired(Joi, 1).label(labeled(label, 'Balance sheet - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Balance sheet -'))
      })
    })
    .when(Joi.object({ isPrimary: boolean(Joi) }).or('isPrimary'), {
      then: Joi.object({
        zoning: enumRequired(Joi, zoningOptions, labeled(label, 'Security Zoning')),
        propertyType: enumRequired(
          Joi,
          propertyTypes,
          labeled(label, 'Security Property type')
        ),
        ownershipType: enumRequired(
          Joi,
          ownershipTypes,
          labeled(label, 'Security Ownership Type')
        ),
        address: addressSchema(Joi, labeled(label, 'Security -')),
        ownership: ownershipSchema(Joi, labeled(label, 'Security -'))
      })
    })
    // other unknown types
    .when('.assetType.id', {
      not: Joi.string().valid(
        'investment_property_address',
        'owner_occupier_property_address',
        'vehicle_make_and_model',
        'bank_accounts',
        'home_contents',
        'kiwisaver',
        'superfund_institution',
        'shares',
        'other',
        'balance_sheet'
      ),
      then: Joi.object({
        value: numberRequired(Joi, 1).label(labeled(label, 'Unknown Asset - Value')),
        ownership: ownershipSchema(Joi, labeled(label, 'Unknown Asset -'))
      })
    });

export default {
  schema
};
